import { render, staticRenderFns } from "./history-dialog.vue?vue&type=template&id=79f84b3a&scoped=true&"
import script from "./history-dialog.vue?vue&type=script&lang=js&"
export * from "./history-dialog.vue?vue&type=script&lang=js&"
import style0 from "./history-dialog.vue?vue&type=style&index=0&id=79f84b3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f84b3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
